<template>
	<div class="forget">
		<h2>
			<strong>{{ $t('login.forget_password') }}</strong>
		</h2>
		<div class="form">
			<el-form :model="login_form" ref="rule">
				<el-form-item
					prop="mobile"
					:rules="[
						{ required: true, message: $t('login.pl_phone'), whitespace: true, trigger: 'blur' },
						{ validator: validatePass, trigger: 'blur' },
					]"
				>
					<el-input
						v-model="login_form.mobile"
						:placeholder="$t('login.pl_phone')"
						autocomplete="off"
					>
						<template #prepend>
							<AreaCode v-model="login_form.areaCode" />
						</template>
					</el-input>
				</el-form-item>
				<el-form-item
					prop="code"
					:rules="[
						{ required: true, message: $t('login.pl_code'), whitespace: true, trigger: 'change' },
					]"
				>
					<el-row :gutter="10">
						<el-col :span="12">
							<el-input
								v-model="login_form.code"
								:placeholder="$t('login.pl_code')"
								autocomplete="off"
							/>
						</el-col>
						<el-col :span="12">
							<Verification
								:formData="{
									sms: 'forgetCode',
									are: login_form.areaCode,
									mobile: login_form.mobile,
								}"
							/>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item
					prop="password"
					:rules="[
						{ required: true, message: $t('login.not_empty'), whitespace: true, trigger: 'change' },
						{ validator: validatePass1, trigger: 'change' },
					]"
				>
					<el-input
						v-model="login_form.password"
						:type="showPass ? 'text' : 'password'"
						:placeholder="$t('login.pl_password')"
						autocomplete="off"
					>
						<template #suffix>
							<i
								class="shopyy-iconfont shopyyicon-Invisible"
								style="cursor: pointer"
								:class="
									showPass
										? 'shopyy-iconfont shopyyicon-View'
										: 'shopyy-iconfont shopyyicon-Invisible'
								"
								@click="showPass = !showPass"
							>
							</i>
						</template>
					</el-input>
				</el-form-item>
				<el-form-item
					prop="againPassword"
					:rules="[
						{ required: true, message: $t('login.not_empty'), whitespace: true, trigger: 'change' },
						{ validator: validatePass1, trigger: 'change' },
					]"
				>
					<el-input
						v-model="login_form.againPassword"
						:type="againpass ? 'text' : 'password'"
						:placeholder="$t('login.pl_pass_again')"
						autocomplete="off"
					>
						<template #suffix>
							<i
								class="shopyy-iconfont shopyyicon-Invisible"
								style="cursor: pointer"
								:class="
									againpass
										? 'shopyy-iconfont shopyyicon-View'
										: 'shopyy-iconfont shopyyicon-Invisible'
								"
								@click="againpass = !againpass"
							>
							</i>
						</template>
					</el-input>
				</el-form-item>
			</el-form>
			<div class="form-btn">
				<el-button type="primary" :loading="loading" @click="modifiy">
					{{ $t('login.confirm_edit') }}
				</el-button>
				<p class="back" @click="cutType('login')">
					<i class="shopyy-iconfont shopyyicon-fanhui" /><span>{{ $t('login.back_login') }}</span>
				</p>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import AreaCode from './compoent/AreaCode.vue'
import type { LogoType } from '../component/account/AccountLogin.vue'
import type { NotPass } from '../types/login'
import { forgetPass } from '../api/login'
import Verification from './compoent/Verification.vue'
import { useStore } from '/@/store'
import { ElMessage } from 'element-plus'
import { i18n } from '/@/i18n'
import { isHW } from '/@/utils'

const emits = defineEmits(['change'])

const { t } = i18n.global
const rule = ref()
const login_form = ref<NotPass>({
	areaCode: '',
	mobile: '',
	brand_id: 0,
	password: '',
	againPassword: '',
	code: '',
})

const loading = ref(false)
const showPass = ref(false)
const againpass = ref(false)
const { state } = useStore()
const modifiy = () => {
	rule.value.validate(async (valid) => {
		if (!valid) return
		await forgetPass({ ...login_form.value, brand_id: state.platForm.id }, loading)
		cutType('login')
		ElMessage.success(t('common.edit_success'))
	})
}

//验证手机号
const validatePass = (rule: any, value: any, callback: any) => {
	if (value.length < 5 || value.length > 18) {
		callback(t('login.valid_phone'))
	} else {
		callback()
	}
}

//验证密码长度
const validatePass1 = (origin: any, value: any, cb: any) => {
	let field = 'againPassword'
	if (origin.field === 'againPassword') {
		field = 'password'
	}

	const regex = /^(?=.*[A-Za-z])(?=.*\d).{7,}$/
	if (!regex.test(value)) {
		return cb(t('login.valid_pass_rule'))
	}
	if (
		origin.field === 'againPassword' &&
		login_form.value.password !== login_form.value.againPassword
	) {
		cb(t('layout.pass_not'))
	}
	// if (login_form.value[field] && value) {
	// 	if (login_form.value[field] !== value) cb(t('layout.pass_not'))
	// 	else rule.value.clearValidate(field)
	// }
	cb()
}
//返回登录
const cutType = (val: LogoType) => {
	emits('change', val)
}
</script>

<style scoped lang="scss">
.forget {
	padding: 0 10px;

	h2 {
		font-size: 18px;
		color: var(--color-assist);
	}

	.form {
		margin-top: 20px;

		.form-btn {
			margin-top: 30px;

			button {
				width: 100%;
			}

			.back {
				display: flex;
				align-items: center;
				justify-content: center;
				margin-top: 20px;
				color: var(--color-primary);
				cursor: pointer;

				i {
					margin-right: 5px;
				}
			}
		}
	}
}
</style>
